$('document').ready(function () {

    if (document.getElementById('addCandidate')) {

        if (document.getElementById('isEdit')) {
            // var focus = 0;
            var data;

            function onchangeEl(el) {
                // focus++;
                // if (focus > 2) {
                    var isValid = el.siblings("small.help-block").attr("data-fv-result");
                    if (isValid == "VALID" || !isValid) {
                        var value;
                        if (el.attr('name') == "avatar") {
                            var value = new FormData();
                            value.append("video", el[0].files[0]);
                            data = {
                                name: el.attr('name'),
                                value: value,
                                is_part_edit: true
                            };
                            console.log(data);
                            $.when(postRequestFile(data, "/Register/Candidate/Set"))
                                .done(function (answer) {
                                    }
                                );
                        } else {
                            value = el.val();
                            data = {
                                name: el.attr('name'),
                                value: value,
                                is_part_edit: true
                            };
                            $.when(postRequest(data, "/Register/Candidate/Set"))
                                .done(function (answer) {
                                    }
                                );
                        }
                    }
            }

            $("input").change(function () {
                onchangeEl($(this));
            });
            $("select").change(function () {
                onchangeEl($(this));
            });
            $("textarea").change(function () {
                onchangeEl($(this));
            });
        }

        $('select[multiple="multiple"]').select2();


        // =========================reg cand======================

        $("#Total_Years_Experience").slider({
            range: true,
            min: 0,
            max: 20,
            values: [0, 2],
            slide: function (event, ui) {
                if(ui.values[1]==20) {
                    $(".Total_Years_Experience").val("" + ui.values[0] + " - 20+");
                }else {
                    $(".Total_Years_Experience").val("" + ui.values[0] + " - " + ui.values[1]);
                }

            },
            change: function( event, ui ) {
                if (document.getElementById('isEdit')) {
                    onchangeEl($(".Total_Years_Experience "));
                }
            }
        });
        var Total_Years_Experience = $(".Total_Years_Experience.isEdit").val();
        if (Total_Years_Experience) {
            var tmp = Total_Years_Experience.split("-");
            var min = Number(tmp[0].replace(/[^-0-9]/gim, ''));
            var max = Number(tmp[1].replace(/[^-0-9]/gim, ''));

            $( "#Total_Years_Experience" ).slider( "option", "values", [ min, max ] );
        }

        // =============================================
        $("#Landed_Rate").slider({
            range: true,
            min: 300,
            max: 2000,
            step: 50,
            values: [300, 2000],
            slide: function (event, ui) {
                $(".Landed_Rate").val("$" + ui.values[0] + " - $" + ui.values[1]);

            },
            change: function( event, ui ) {
                if (document.getElementById('isEdit')) {
                    onchangeEl($(".Landed_Rate"));
                }
            }
        });
        var Landed_Rate = $(".Landed_Rate.isEdit").val();
        if (Landed_Rate && Landed_Rate.indexOf("-")!=-1) {
            var tmp = Landed_Rate.split("-");
            var min = Number(tmp[0].replace(/[^-0-9]/gim, ''));
            var max = Number(tmp[1].replace(/[^-0-9]/gim, ''));

            $( "#Landed_Rate" ).slider( "option", "values", [ min, max ] );
        }






        // ===============================================
        $("#Target_Annual_Base_Range").slider({
            range: true,
            min: 50000,
            max: 200000,
            step: 1000,
            values: [50000, 200000],
            slide: function (event, ui) {
                $(".Target_Annual_Base_Range").val("$" + ui.values[0] + " - $" + ui.values[1]);

            },
            change: function( event, ui ) {
                if (document.getElementById('isEdit')) {
                    onchangeEl($(".Target_Annual_Base_Range"));
                }
            }
        });
        var Target_Base_Range = $(".Target_Annual_Base_Range.isEdit").val();
        if (Target_Base_Range) {
            var tmp = Target_Base_Range.split("-");
            var min = Number(tmp[0].replace(/[^-0-9]/gim, ''));
            var max = Number(tmp[1].replace(/[^-0-9]/gim, ''));

            $( "#Target_Annual_Base_Range" ).slider( "option", "values", [ min, max ] );
        }

        $("#Target_Daily_Rate").slider({
            range: true,
            min: 300,
            max: 1500,
            step: 50,
            values: [300, 1500],
            slide: function (event, ui) {
                $(".Target_Daily_Rate").val("$" + ui.values[0] + " - $" + ui.values[1]);

            },
            change: function( event, ui ) {
                if (document.getElementById('isEdit')) {
                    onchangeEl($(".Target_Daily_Rate"));
                }
            }
        });
        var Target_Daily_Rate = $(".Target_Daily_Rate.isEdit").val();
        if (Target_Daily_Rate) {
            var tmp2 = Target_Daily_Rate.split("-");
            var min2 = Number(tmp2[0].replace(/[^-0-9]/gim, ''));
            var max2 = Number(tmp2[1].replace(/[^-0-9]/gim, ''));

            $( "#Target_Daily_Rate" ).slider( "option", "values", [ min2, max2 ] );
        }

// ====================

        // $('.addsteps[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        //     $(".People-Account .step").removeClass("step");
        // });

        $('#rates_switcher').change(function () {
            $('.rate-box').hide();
            var rates = $(this).val();
            if (rates) {
                for (var u = 0; u < rates.length; u++) {
                    $('#' + rates[u]).show();
                }
            }
        });

        var rates = $('#rates_switcher').val();
        if (rates) {
            for (var u = 0; u < rates.length; u++) {
                $('#' + rates[u]).show();
            }
        }

        $('.second-inp').select2({
            "language": {
                "noResults": function () {

                    if ($('#sap_skills').val()) {
                        // var $preview = $("<p id='suggestion' style='cursor: pointer'>Suggest \"" + $('.skills_category .select2-search__field').val() + "\" as a SAP Skill</p>");
                        var $preview = $("<p id='' >Select a new module to view other skills category</p>");
                    } else {
                        var $preview = $("<p id='' >Select a category first to see SAP skills options</p>");
                    }


                    $preview.on('click', function (evt) {
                        var suggestText = $('.skills_category .select2-search__field').val();
                        var skill_category_type_id = $('#sap_skills').val();
                        if (suggestText && skill_category_type_id) {
                            var data = {
                                skill_category_type_id: skill_category_type_id[0],
                                suggest: suggestText
                            };
                            $.ajax({
                                    headers: {
                                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                                    },
                                    url: "/api/skill/suggest",
                                    data: data,
                                    dataType: 'json',
                                    type: 'POST'
                                }
                            ).done(function (result) {
                                var answer = result.answer;
                            });
                        }
                    });
                    return $preview;
                }
            },

            escapeMarkup: function (markup) {
                return markup;
            }
        })

        var skills_edit = $(".second-inp").val();
        var sap_module = $("#sap_skills").val();
        function eventOnSearchBySkills(data, tab) {
            var options1 = [];
            var options2 = {};
            data.sort(function(a, b){
                return b["name"] < a["name"] ? 1 : -1;
            });
            data.forEach(function (item, i) {
                var option1;
                option1 = new Option(item['name'], item['id']);
                options2[item['id']] = [];

                item["parameters"].forEach(function (item2, j) {
                    var option2 = [];
                    if (item2["name"] != "Other") {
                        option2 = new Option(item2['name'], item2['id']);
                        options2[item['id']].push(option2);
                    }
                })
                options1.push(option1);
            });
            options1.sort(function(a, b){
                return b["label"] < a["label"] ? 1 : -1;
            });

            $(tab + " .first-inp").html("").append(options1);

            $('#sap_skills').val(sap_module).trigger('change');

            // ==================if edit=========
            var sap_skills_edit = $("#sap_skills").val();
            var options = [];
            if (sap_skills_edit) {
                sap_skills_edit.forEach(function (item, i) {
                    options = options.concat(options2[item]);
                });
            }
            options.sort(function(a, b){
                return b["label"] < a["label"] ? 1 : -1;
            });
            $(tab + " .second-inp").html("").append(options);
            $('#sap_skills_2').val(skills_edit).trigger('change');
            // ===========================

            $(tab + "  .first-inp").on("change", function () {

                var firstVal = $(this).val();
                var options = [];
                if (firstVal) {
                    firstVal.forEach(function (item, i) {

                        options = options.concat(options2[item]);

                    });
                }
                options.sort(function(a, b){
                    return b["label"] < a["label"] ? 1 : -1;
                });
                $(tab + " .second-inp").html("").append(options);
            });

        }

        var category = {data: ["SAP"]};

        $.when(postRequest(category, "/api/get/skills/all"))
            .done(function (answer) {
                    var data = answer[0]['category_type'];
                    eventOnSearchBySkills(data, "#addCandidate");
                }
            );


        //=================request============================

        function postRequest(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'POST',
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }

        function postRequestFile(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'POST',
                    contentType: false,
                    processData: false,
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }

        $("#datepicker").datepicker({
            maxDate: "0",
            yearRange: "c-100:c",
            changeYear: true,
            changeMonth: true,
            dateFormat: "dd.mm.yy",
        });
        $('#datepicker').datepicker('setDate', "01.01.1980");

    }
});